
import { Component, Vue } from 'vue-property-decorator';
import NoteItem from './Note.vue';
import { Note } from '@/store/types';
import { namespace } from 'vuex-class';

const notesModule = namespace('notes');

@Component({
  components: {
    NoteItem,
  },
})
export default class Notes extends Vue {
  @notesModule.State
  notes!: Note[];
}
